import { apiGet } from '../../generic/Api_Functions'
import { getRandomUUID } from '../../generic/utilities/randomuuid'

/**
 * Fetches the job nodes for a workflow and loads it into the balanced state.
 *
 * Story 146 / S66 (RN30.1, D30): the response's `extern` flag is loaded AS IS and every node,
 * external included, enters `balancedData.nodes`. The external ones are kept out of the matrix
 * further down (`isExternalJobNode`, one gate per entry point) instead of being dropped here on
 * purpose: `previousNodes`/`nextNodes` of an external node are part of the line-advancement graph,
 * and removing it would silently relax the floor of the internal nodes that follow it (their
 * predecessor would stop resolving), which S66 requires to stay exactly as today.
 *
 * @param {Object} workflow - Full workflow entity (id, balancedType, balancedApproved,
 *   deviceGroup|positions, partReference)
 * @param {Function} dispatchBalancedData - Reducer dispatcher from Balanced
 * @returns {Promise<boolean>} true on success, false on fetch error
 */
export const loadWorkflowIntoBalanced = async (workflow, dispatchBalancedData) => {
  const response = await apiGet('workflowJobNodes/' + workflow.id)
  if (!response || response.error) return false
  response.tempWorkflowUUID = getRandomUUID()
  dispatchBalancedData({
    type: 'SET_WORKFLOW',
    workflow,
    nodes: response,
    partReference: { id: workflow.partReference.id, code: workflow.partReference.code, name: workflow.partReference.name },
    editing: false
  })
  return true
}
